export default {
  SaleManager: 12,
  CompanyAccount2: 8,
  ManagerAccount: 11,
  OriginWarehouse: 1,
  DestinationWarehouse: 2,
  CompanySale: 3,
  PlatformAccount1: 4,
  PlatformAccount2: 5,
  PlatformAccount3: 6,
  CompanyAccount1: 7,
  CompanyAccount3: 9,
  CompanyOwner: 10,
};
